import React, { Fragment } from 'react';

import SelectOrgUnit from '@usas/ui-web/components/selectOrgUnit/SelectOrgUnit';

import useOrgUnitSelection from './UseOrgUnitSelection';

const OrgUnitSelection = () => {
  const { 
    NavLinks, 
    getBaseUsasClubByOrgUnitId, 
    CLUB_RENEWAL_SELECTOR_ROLE_GROUP_ID, TAXONOMIES, SCOPE } = useOrgUnitSelection();

  return (
    <Fragment>
      <SelectOrgUnit
        pageTitle={'Club Renewal'}
        navLink={NavLinks.CLUB_RENEWAL_RENEW}
        roleGroupId={CLUB_RENEWAL_SELECTOR_ROLE_GROUP_ID}
        getFunction={getBaseUsasClubByOrgUnitId}
        TAXONOMIES={TAXONOMIES}
        SCOPE={SCOPE} />
    </Fragment>
  );
};

export default OrgUnitSelection;